export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  ctaInscription: "home-cta-inscription",
  ctaPlanning: "home-cta-planning",
};

export const NAV = {
  header: "nav-header",
  logo: "nav-logo",
  menuToggle: "nav-menu-toggle",
  mobileMenu: "nav-mobile-menu",
  ctaInscription: "nav-cta-inscription",
};

export const BOTTOM = {
  bar: "mobile-bottom-bar",
  planning: "mobile-bottom-planning",
  essai: "mobile-bottom-essai",
  inscription: "mobile-bottom-inscription",
};

export const PLAN = {
  root: "planning-root",
  filterCity: "planning-filter-city",
  filterDay: "planning-filter-day",
  filterCategory: "planning-filter-category",
  filterAudience: "planning-filter-audience",
  filterLevel: "planning-filter-level",
  filterTeacher: "planning-filter-teacher",
  resetFilters: "planning-filter-reset",
  courseCard: "planning-course-card",
  courseCta: "planning-course-cta",
};

export const CONTACT = {
  form: "contact-form",
  firstName: "contact-first-name",
  lastName: "contact-last-name",
  email: "contact-email",
  phone: "contact-phone",
  subject: "contact-subject",
  pole: "contact-pole",
  message: "contact-message",
  submit: "contact-submit",
};

export const INSC = {
  form: "inscription-form",
  firstName: "inscription-first-name",
  lastName: "inscription-last-name",
  email: "inscription-email",
  phone: "inscription-phone",
  age: "inscription-age",
  city: "inscription-city",
  disciplines: "inscription-disciplines",
  level: "inscription-level",
  message: "inscription-message",
  consent: "inscription-consent",
  submit: "inscription-submit",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabCourses: "admin-tab-courses",
  tabTeachers: "admin-tab-teachers",
  tabLocations: "admin-tab-locations",
  tabEvents: "admin-tab-events",
  tabContacts: "admin-tab-contacts",
  tabInscriptions: "admin-tab-inscriptions",
  tabDisciplines: "admin-tab-disciplines",
  tabFormulas: "admin-tab-formulas",
  tabNews: "admin-tab-news",
  tabSettings: "admin-tab-settings",
  tabPartners: "admin-tab-partners",
  tabGallery: "admin-tab-gallery",
  settingsSave: "admin-settings-save",
};
